export default __webpack_public_path__ + "static/media/Japan_Particle_0005_Yamato_Fireball.9d675e8a.png";